import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './Service/login.service';

@Component({
  selector: 'app-externallogin',
  templateUrl: './externallogin.component.html',
  styleUrls: ['./externallogin.component.css'],
  providers: [LoginService],
})
export class ExternalloginComponent implements OnInit {
  loginInformation: any[] = [];
  email: string;
  password: string;
  Login: any = {};
  LoginDetails: any = {};
  show = false;
  type: string;
  showlabel: boolean;
  showErrorMsg: boolean;
  emailPattern: any;
  errorMessage: string;
  showPassword: boolean;
  loginAttemptsRemailning: number;//Arvind

  constructor(private router: Router
    , private route: ActivatedRoute, private loginService: LoginService) {

    this.emailPattern = '^[A-Za-z0-9._%+-]{2,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$';
    this.type = 'password';
    this.showPassword = false;
  }

  ngOnInit() {
    this.showlabel = true;
    this.showErrorMsg = false;
    this.loginAttemptsRemailning= 10; //Arvind
  }
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
    this.showlabel = false;
  }
  loginsubmit(event) {
    // debugger;
    this.Login.email = this.email;
    this.Login.password = this.password;

    this.loginService.GetLogin(this.Login).subscribe(
      p => {
        // debugger;
        this.LoginDetails = p;

        if (this.LoginDetails.loginStatus === 'Failure') {
          // this.errorMessage = 'Incorrect User ID or Password.';
          // this.showErrorMsg = true;
          //Arvind Start
          if (this.loginAttemptsRemailning == 1) {
            this.errorMessage = "You have exceeded the login attepts";
            this.showErrorMsg = true;
            // Logout url and lockout account.
            this.loginService.LockUser(this.Login).subscribe(
              result=>{})

          } else if (this.loginAttemptsRemailning > 1) {
            this.loginAttemptsRemailning = this.loginAttemptsRemailning - 1;
            this.errorMessage = `You have entered Incorrect User ID or Password. Number of attempts remaining ${this.loginAttemptsRemailning}`;
            this.showErrorMsg = true;
          }
          //Arvind Stop
          
        } else if (this.LoginDetails.loginStatus === 'FirstExpired') {
          this.errorMessage = 'Your password has expired. New users should login within 24 hours of setting up their account. We have generated and sent a new password to your email. Please use the same.';
          this.showErrorMsg = true;
        } else if (this.LoginDetails.loginStatus === 'ChangeExpired') {
          this.errorMessage = 'Your password has expired. Users should login within 2 hours of resetting their passwords. Please reset your password using the Forgot Password link below.';
          this.showErrorMsg = true;
        } else {

          sessionStorage.setItem('firstname', this.LoginDetails.user.firstName);
          sessionStorage.setItem('lastname', this.LoginDetails.user.lastName);
          sessionStorage.setItem('emailid', this.LoginDetails.user.emailID);
          sessionStorage.setItem('userid', this.LoginDetails.user.userID);
          sessionStorage.setItem('isAgencyUnassigned', this.LoginDetails.isAgencyUnassigned);
          sessionStorage.setItem('userType', 'E');
          sessionStorage.setItem('userRoleId', this.LoginDetails.user.userRoleID);
          sessionStorage.setItem('token',this.LoginDetails.token)

          if (this.LoginDetails.loginStatus === 'First') {
            this.router.navigate(['Registration']);
          } else if (this.LoginDetails.loginStatus === 'Change') {
            this.router.navigate(['ChangePassword']);
          } else if (this.LoginDetails.loginStatus === 'Expired') {
            this.router.navigate(['ChangePassword']);
          } else if (this.LoginDetails.loginStatus === 'Success') {
            this.router.navigate(['Invoice']);
          }

        }

      }
    );


  }

  forgotPassword() {
    this.router.navigate(['ForgotPassword']);
  }

  callLoginByEnter(event) {
    // debugger;
    event.preventDefault();
    if (event.keyCode === 13) {
      let submitBtn = document.getElementById('enterlogin');
      submitBtn.click();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/externallogin/externallogin.component.ts